"use client"
import Map from "./map"
import { Button } from "../ui/button"
import { siteConfig } from "@/data/site-data"
import { motion } from "framer-motion"

export default function Contact() {
  return (
    <section id="contact" className="lg:mb-50 relative overflow-hidden">

      <div>
        <div className="h-full w-full min-h-[70svh] relative ">
          <div className="absolute h-full w-full scale-90 -translate-x-200 lg:-translate-x-24">
            <Map />
          </div>
          <div className="absolute h-full w-full bg-linear-to-b to-background via-background/20 from-background" />
          <div className="overflow-hidden p-0 h-full min flex items-center justify-center absolute w-full">
            <motion.div
              className="py-8 xl:py-16 px-8 text-center z-10"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <motion.h2
                className="text-3xl lg:text-5xl font-brand text-foreground mb-6"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                Ready to Start Your Project ?
              </motion.h2>
              <motion.p
                className="tracking-[-1.5px] text-xl text-foreground/70 font-light mb-10 max-w-2xl mx-auto leading-relaxed"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.4 }}
              >
                Let's discuss how we can help bring your vision to life with a custom solution tailored to your needs and goals.
              </motion.p>
              <motion.div
                className="flex justify-center lg:flex-row flex-col gap-3"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.6 }}
              >
                <Button
                  size="lg"
                  variant="ghost"
                  className="bg-white text-background ease-in-out duration-300 transition-all h-12 rounded-full tracking-[-0.5px]"
                >
                  {siteConfig.email}
                </Button>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  )
}